// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets-kios/css/style.css
// module id = 1528
// module chunks = 173